import React from "react";

type CardProps = {
  className?: string;
  children?: React.ReactNode;
};

const Card = ({ className = "", children }: CardProps) => {
  return (
    <div
      className={
        "bg-white rounded-xl border border-gray-200 shadow-sm transition-shadow hover:shadow-md " +
        className
      }
    >
      {children}
    </div>
  );
};

export default Card;
